/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fa-7x[_ngcontent-%COMP%]{font-size:7em}\n/*# sourceMappingURL=post-login-page.component.css.map*/"];
export { styles as styles };
